import { render, staticRenderFns } from "./pending.vue?vue&type=template&id=0fdcf8c8&"
import script from "./pending.vue?vue&type=script&lang=js&"
export * from "./pending.vue?vue&type=script&lang=js&"
import style0 from "./pending.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports